import { object, string, boolean, date, number, array, InferType } from "yup";

const enderecoSchema = object({
  cep: string().required("CEP é obrigatório"),
  logradouro: string().required("Logradouro é obrigatório"),
  numero: string().required("Número é obrigatório"),
  complemento: string().nullable(),
  bairro: string().required("Bairro é obrigatório"),
  estado: string().required("Estado é obrigatório"),
  cidade: string().required("Cidade é obrigatória")
});

const responsavelSchema = object({
  nome: string().required("Nome do responsável é obrigatório"),
  email: string().email("Email inválido").required("Email é obrigatório"),
  telefone: string()
    .required("Telefone é obrigatório")
    .test({
      name: "phone",
      message: "Telefone inválido. Use o formato (##) ####-#### ou (##) #####-####",
      test: function (value) {
        if (typeof value !== "string" || value.length === 0) {
          return true;
        }
        const numbers = value.replaceAll(/\D/g, "");
        return numbers.length === 10 || numbers.length === 11;
      }
    })
});

const acessosSchema = object({
  admin: number().required(),
  member: number().required(),
  team: number().required(),
  master: number().required(),
  collaborator: number().required()
});

const autorizacoesSchema = object({
  gestao: boolean().required("Gestão é obrigatória"),
  diagnostico: boolean().required("Diagnóstico é obrigatório"),
  incentivo: boolean().required("Incentivo é obrigatório"),
  configuracoes: boolean().required("Configurações é obrigatória")
});

const licenciadaSchema = object({
  cnpj: string().required("CNPJ é obrigatório"),
  razaoSocial: string().required("Razão social é obrigatória"),
  nomeFantasia: string().required("Nome fantasia é obrigatório"),
  email: string().email("Email inválido").required("Email é obrigatório"),
  telefone: string()
    .required("Telefone é obrigatório")
    .test({
      name: "phone",
      message: "Telefone inválido. Use o formato (##) ####-#### ou (##) #####-####",
      test: function (value) {
        if (typeof value !== "string" || value.length === 0) {
          return true;
        }
        const numbers = value.replaceAll(/\D/g, "");
        return numbers.length === 10 || numbers.length === 11;
      }
    }),
  status: string().default("ATIVO"),
  contratoInicio: date().required("Data de início do contrato é obrigatória"),
  contratoFim: date().required("Data de fim do contrato é obrigatória"),
  responsavel: responsavelSchema.optional(),
  endereco: enderecoSchema.required(),
  acessos: acessosSchema.required(),
  autorizacoes: autorizacoesSchema.required()
});

const empresaSchema = object({
  cnpj: string().required("CNPJ é obrigatório"),
  razaoSocial: string().required("Razão social é obrigatória"),
  nomeFantasia: string().required("Nome fantasia é obrigatório"),
  email: string().email("Email inválido").required("Email é obrigatório"),
  telefone: string().required("Telefone é obrigatório"),
  codigoCNAE: string().required("Código CNAE é obrigatório"),
  cnae: string().required("CNAE é obrigatório"),
  porte: string().required("Porte da empresa é obrigatório"),
  setores: array().of(string().required()).min(1, "Adicione pelo menos um setor").required("Setores são obrigatórios"),
  status: string().default("ATIVO"),
  numeroColaboradores: string().required("Número de colaboradores é obrigatório"),
  responsavel: responsavelSchema.required(),
  colaboradores: string().default(""),
  endereco: enderecoSchema.required(),
  role: string().default("NORMAL")
});

const templateSchema = object({
  licenciadaId: string().optional(), // Será preenchido automaticamente
  empresaId: string().required("Empresa modelo é obrigatória"),
  collections: array().of(string().required()).default([]).label("Collections para importar")
});

const adminSchema = object({
  nome: string().required("Nome do administrador é obrigatório"),
  email: string().email("Email inválido").required("Email do administrador é obrigatório"),
  telefone: string()
    .required("Telefone é obrigatório")
    .test({
      name: "phone",
      message: "Telefone inválido. Use o formato (##) ####-#### ou (##) #####-####",
      test: function (value) {
        if (typeof value !== "string" || value.length === 0) {
          return true;
        }
        const numbers = value.replaceAll(/\D/g, "");
        return numbers.length === 10 || numbers.length === 11;
      }
    })
});

export const createLicenciadaSchema = object({
  novaLicenciada: licenciadaSchema.required(),
  novaEmpresa: empresaSchema.required(),
  template: templateSchema.required(),
  admin: adminSchema.required()
});

export type CreateLicenciadaFormData = InferType<typeof createLicenciadaSchema>;

export default createLicenciadaSchema;
